import React from 'react'
import "./Checkbox.css"

function Checkbox({ label, style , ...rest }) {
    return (
        <div style={style}>
            <label className="checkmark-container">{label}
                <input type="checkbox" {...rest}/>
                <span className="checkmark"></span>
            </label>
        </div>
    )
}

export default Checkbox
